import { Box, Img, Text } from "@chakra-ui/react";
import Bg from "../../../../assets/gradientbg.svg";
import IncludeBallAnimation from "../../../../components/IncludeBallAnimation";
import Arrow from "../../assets/arrow/arrow.png";

const Hero = () => {
  return (
    <Box
      position="relative"
      backgroundImage={Bg}
      padding={["5.5rem 2rem 1rem 2rem", "5.5rem 6rem 1rem 6rem"]}
      height={["100%", "100%", "100%", "100vh"]}
      backgroundSize="cover"
    >
      <Img
        loading="lazy"
        width="4%"
        className="arrow"
        position="absolute"
        top="55%"
        right="23%"
        src={Arrow}
      />

      <IncludeBallAnimation />

      <Box data-aos="fade-up">
        <Text marginTop="140px" fontSize="1.4rem" color="#290F44">
          SERVICES
        </Text>
        <Text
          marginTop="1.5rem"
          maxWidth="600px"
          lineHeight={["50px", "80px"]}
          fontSize={["2rem", "4rem"]}
          className="bolder"
          color="#290F44"
        >
          FROM RESEARCH TO DELIVERY
        </Text>
        <Text
          marginTop="1.5rem"
          fontWeight="500"
          fontSize="1.4rem"
          color="#290F44"
        >
          Integrity and transparency always in the first place.
        </Text>
      </Box>
    </Box>
  );
};

export default Hero;
